import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import type { CheckedState } from "src/components/CheckboxV2/CheckboxV2.types.ts";

export const outerContainer = css`
  position: relative;
`;

export const innerContainer = css`
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
`;

export const label =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) => css`
    font-size: ${theme.fontSizesV2.body};
    color: ${theme.checkboxV2Color[disabled ? "disabled" : "normal"]};
    user-select: none;
    cursor: ${disabled ? "not-allowed" : "pointer"};
  `;

export const root =
  ({
    checked,
    disabled,
    hasError,
  }: {
    checked: CheckedState;
    disabled: boolean;
    hasError: boolean;
  }) =>
  ({ colorsV2, outlineV2, borderRadiusV2 }: ExactTheme) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
    position: relative;
    cursor: ${disabled ? "not-allowed" : "pointer"};
    border-radius: ${borderRadiusV2.secondary};
    width: 20px;
    height: 20px;
    border-style: solid;
    border-width: 1px;
    color: ${disabled
      ? colorsV2.grey[200]
      : hasError
      ? colorsV2.red[500]
      : "white"};
    border-color: ${disabled
      ? colorsV2.grey[200]
      : hasError
      ? colorsV2.red[500]
      : checked === "indeterminate"
      ? colorsV2.blue[500]
      : checked
      ? colorsV2.blue[500]
      : colorsV2.grey[600]};

    background: ${disabled
      ? colorsV2.grey[50]
      : hasError
      ? colorsV2.red[25]
      : checked === "indeterminate"
      ? colorsV2.blue[500]
      : checked
      ? colorsV2.blue[500]
      : "white"};

    &:hover {
      outline: ${disabled || hasError
        ? "none"
        : `3px solid ${outlineV2.checkbox}`};
      border-color: ${disabled
        ? colorsV2.grey[200]
        : hasError
        ? colorsV2.red[500]
        : colorsV2.blue[500]};
    }
  `;

export const input = css`
  appearance: none;
  position: absolute;
  opacity: 0;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  cursor: inherit;
`;
